export default "__VITE_ASSET__CO2Li5S6__"